import { ORDER_BY, sortDirection } from 'utils/constants';

export const getSGPs = ({
    orderBy = ORDER_BY.name,
    direction = sortDirection.ASC,
    ...payload
}) => ({
    [`order[${orderBy}]`]: direction,
    ...payload,
});
